import { render, staticRenderFns } from "./letterManagement.vue?vue&type=template&id=518bc030&scoped=true"
import script from "./letterManagement.vue?vue&type=script&lang=js"
export * from "./letterManagement.vue?vue&type=script&lang=js"
import style0 from "./letterManagement.vue?vue&type=style&index=0&id=518bc030&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "518bc030",
  null
  
)

export default component.exports